<template>
  <div class="container-fluid py-4 users-page">

    <!-- ================= HEADER ================= -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-boutique flex-wrap">

      <div class="d-flex align-items-center gap-3">

        <div class="icon-box">
          <i class="bi bi-person-plus"></i>
        </div>

        <div>
          <h2 class="fw-bold mb-0 text-white">
            Création d'un Utilisateur
          </h2>

          <small class="text-white-50">
            Les accès seront envoyés automatiquement par email
          </small>
        </div>

      </div>

      <router-link
        class="btn btn-light btn-lg shadow-sm btn-boutique"
        :to="{ name: 'utilisateur' }"
      >
        <i class="bi bi-arrow-left-circle me-2"></i>
        Retour
      </router-link>

    </div>

    <!-- ================= CARD ================= -->
    <div class="card shadow-sm card-boutique p-4">

      <!-- INFO -->
      <div class="info-box mb-4">
        <i class="bi bi-envelope-check-fill text-success fs-3"></i>

        <div>
          <h6 class="fw-bold mb-1">Création automatique des accès</h6>
          <p class="mb-0 text-muted small">
            Un mot de passe temporaire sera généré et envoyé à l'utilisateur.
          </p>
        </div>
      </div>

      <!-- FORM -->
      <div class="row g-4">

        <!-- NOM -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Nom</label>
          <input v-model="user.nom" type="text"
                 class="form-control form-control-boutique"
                 :class="{ 'is-invalid': error.nom }">
          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>

        <!-- PRENOM -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Prénom</label>
          <input v-model="user.prenom" type="text"
                 class="form-control form-control-boutique"
                 :class="{ 'is-invalid': error.prenom }">
          <div class="invalid-feedback">{{ error.prenom }}</div>
        </div>

        <!-- USERNAME -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Nom utilisateur</label>
          <input v-model="user.username" type="text"
                 class="form-control form-control-boutique"
                 :class="{ 'is-invalid': error.username }">
          <div class="invalid-feedback">{{ error.username }}</div>
        </div>

        <!-- EMAIL -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Email</label>
          <input v-model="user.email" type="email"
                 class="form-control form-control-boutique"
                 :class="{ 'is-invalid': error.email }">
          <div class="invalid-feedback">{{ error.email }}</div>
        </div>

        <!-- ROLE -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Rôle</label>

          <select v-model="user.typeUser"
                  class="form-select form-control-boutique"
                  :class="{ 'is-invalid': error.type }">

            <option value="">-- Sélectionnez --</option>

            <option
              v-for="type in typesUser.filter(t => t.nom !== 'Super Admin')"
              :key="type.id"
              :value="type.id"
            >
              {{ type.nom }}
            </option>

          </select>

          <div class="invalid-feedback">{{ error.type }}</div>
        </div>

        <!-- STATUS -->
        <div class="col-md-6 d-flex align-items-center">

          <div class="form-check form-switch status-switch">

            <input class="form-check-input" type="checkbox" v-model="user.enabled">

            <label class="form-check-label fw-semibold ms-2">
              Utilisateur activé
            </label>

          </div>

        </div>

      </div>

      <!-- BUTTONS -->
      <div class="d-flex justify-content-end gap-3 mt-4">

        <button class="btn btn-outline-secondary" @click="cancel">
          Annuler
        </button>

        <button class="btn btn-primary-medical px-4"
                :disabled="isLoading"
                @click="saveUser">

          <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>

          <i v-else class="bi bi-save me-1"></i>

          {{ isLoading ? 'Création...' : 'Créer' }}
        </button>

      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {

      isLoading: false,

      user: {
        nom: '',
        prenom: '',
        username: '',
        email: '',
        enabled: true,
        typeUser: ''
      },

      error: {
        nom: '',
        prenom: '',
        username: '',
        email: '',
        type: ''
      },

      typesUser: []

    };
  },

  methods: {

    async getTypeUser() {
      const res = await api.getItems('type_users');
      this.typesUser = res.data.data;
    },

    validateForm() {

      this.error.nom = this.user.nom ? '' : 'Nom requis';
      this.error.prenom = this.user.prenom ? '' : 'Prénom requis';
      this.error.username = this.user.username ? '' : 'Username requis';
      this.error.email = this.user.email ? '' : 'Email requis';
      this.error.type = this.user.typeUser ? '' : 'Rôle requis';

      return !Object.values(this.error).some(e => e);
    },

    async saveUser() {

      if (!this.validateForm() || this.isLoading) return;

      this.isLoading = true;

      try {

        await api.createItem('users', {
          ...this.user
        });

        this.$router.push({ name: 'utilisateur' });

      } catch (e) {
        console.error(e);
        alert("Erreur lors de la création");
      } finally {
        this.isLoading = false;
      }

    },

    cancel() {
      this.$router.push({ name: 'utilisateur' });
    }

  },

  mounted() {
    this.getTypeUser();
  }

};
</script>

<style scoped>

/* ================= GLOBAL ================= */
.users-page {
  background: #f4f7fb;
  min-height: 100vh;
}

/* ================= HEADER ================= */
.header-boutique {
  background: linear-gradient(135deg, #0f4c81, #071a2e);
  color: white;
  padding: 20px;
  border-radius: 18px;
}

.icon-box {
  width: 50px;
  height: 50px;
  background: rgba(255,255,255,0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

/* ================= CARD ================= */
.card-boutique {
  border: none;
  border-radius: 18px;
}

/* ================= INPUT ================= */
.form-control-boutique,
.form-select-boutique {
  border-radius: 10px;
  border: 1px solid #dbe3ee;
}

/* ================= INFO BOX ================= */
.info-box {
  display: flex;
  gap: 12px;
  padding: 15px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
}

/* ================= SWITCH ================= */
.status-switch {
  background: #f8fafc;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

/* ================= BUTTON ================= */
.btn-primary-medical {
  background: linear-gradient(135deg, #0f4c81, #10b981);
  border: none;
  color: white;
  border-radius: 12px;
}

.btn-primary-medical:hover {
  opacity: 0.95;
}

</style>